import { useCallback, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import {
  parseDateRange,
  stringifyDateRange,
} from 'components/organisms/projects-report/common/range-picker/transformer';
import {
  DateRange,
  getRangeObject,
  Range,
} from 'components/organisms/projects-report/common/range-picker/types';
import { useSearch } from 'hooks/use-search';

export const RangeOptions = [
  Range.ThisWeek,
  Range.LastWeek,
  Range.ThisMonth,
  Range.LastMonth,
  Range.ThisQuarter,
  Range.Custom,
];

export const useDateRangeFilter = () => {
  const [search, setSearch, getNext] = useSearch<{ range: DateRange }>({
    from: (value) => {
      const range = parseDateRange(
        (value.range ?? '') as string,
        getRangeObject(Range.ThisMonth),
      );

      return { range };
    },
    to: (value) => {
      return { range: stringifyDateRange(value.range) };
    },
  });

  const [selectedRange, setSelectedRange] = useState<DateRange>(search.range);

  useDeepCompareEffect(() => {
    setSelectedRange(search.range);
  }, [search.range]);

  const setDateRange = useCallback(
    (range: DateRange) => {
      setSearch({ range });
    },
    [setSearch],
  );

  return {
    dateRange: selectedRange,
    setDateRange,
    getNext,
  };
};
